
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import './Home.css';
import ImageSlider from './ImageSlider';
import Footer from './Footer';


const Home = () => {
  const [text, setText] = useState('');

  useEffect(() => {
    const phrases = ['Welcome to the Home Page', 'Explore our amazing products!'];

    let currentPhraseIndex = 0;
    let currentCharIndex = 0;

    const typingEffect = () => {
      if (currentPhraseIndex === phrases.length) {
        currentPhraseIndex = 0;
      }

      const currentPhrase = phrases[currentPhraseIndex];
      setText(currentPhrase.substring(0, currentCharIndex));

      if (currentCharIndex < currentPhrase.length) {
        currentCharIndex++;
        setTimeout(typingEffect, 100);
      } else {
        setTimeout(() => {
          currentCharIndex = 0;
          currentPhraseIndex++;
          typingEffect();
        }, 2000);
      }
    };

    typingEffect();

    return () => {
     
    };
  }, []);

  return (
    <>
    <div className="home-container">
      <h1>{text}</h1>
      
      <p style={{color:"#F9EDEA"}}>Explore our amazing products!</p>
      <Link to="/products">
        <button style={{borderRadius:"10% 30% 0%" ,}}>Explore Products</button>
      </Link>
    </div>
    <ImageSlider/>
    <Footer/>
    </>

  );
};

export default Home;


